import { useTrail } from "react-spring"

import config from "@config"

const { pageDelay, pageTotalDuration } = config

const pageEstimatedAnimationDuration = 500

export const calcDelay = (
  step,
  active,
  totalDuration = pageTotalDuration,
  remainWhenInactive = false // 在页面消失后再还原
) => {
  return active
    ? totalDuration * step + pageDelay + pageEstimatedAnimationDuration
    : remainWhenInactive
    ? pageDelay + pageEstimatedAnimationDuration
    : totalDuration * (1 - step) * 0.7
}

export const useEnteringTrail = (
  size,
  pageOffset,
  { step = 0.1, totalDuration, remainWhenInactive, type = "fade" } = {}
) => {
  const active = pageOffset === 0
  const opacity = active ? 1 : 0
  const offsetLength = 300
  const currentOffset = pageOffset * offsetLength
  const transform = (x, y) => `translate3d(${x}px, ${y}px, 0)`
  const animate =
    typeof type === "string"
      ? {
          fade: {
            from: { opacity: 0 },
            to: { opacity },
          },
          mt: {
            from: {
              opacity: 0,
              transform: transform(0, -offsetLength),
            },
            to: {
              opacity,
              transform: transform(0, -currentOffset),
            },
          },
          mlt: {
            from: {
              opacity: 0,
              transform: transform(-offsetLength, -offsetLength),
            },
            to: {
              opacity,
              transform: transform(-currentOffset, -currentOffset),
            },
          },
          mrt: {
            from: {
              opacity: 0,
              transform: transform(offsetLength, -offsetLength),
            },
            to: {
              opacity,
              transform: transform(currentOffset, -currentOffset),
            },
          },
          mb: {
            from: {
              opacity: 0,
              transform: transform(0, offsetLength),
            },
            to: {
              opacity,
              transform: transform(0, currentOffset),
            },
          },
          mrb: {
            from: {
              opacity: 0,
              transform: transform(offsetLength, offsetLength),
            },
            to: {
              opacity,
              transform: transform(currentOffset, currentOffset),
            },
          },
          mlb: {
            from: {
              opacity: 0,
              transform: transform(-offsetLength, offsetLength),
            },
            to: {
              opacity,
              transform: transform(-currentOffset, currentOffset),
            },
          },
        }[type]
      : type
  return useTrail(size, {
    delay: calcDelay(step, active, totalDuration, remainWhenInactive),
    ...animate,
  })
}

export const callYou = (data) => {
  return data.myself ? "你" : "TA"
}
